import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import ShellApp from './Scanner/ShellApp';
import { inShell } from './Scanner/shell';
import './index.css';
import { applyInstanceChrome } from './instance';
import { installInputModality } from './components/ui/inputModality';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Tab title, favicon and PWA manifest for this deployment. No-op for Firefly.
applyInstanceChrome();

// data-input on <html>: index.css hides focus rings on a click and keeps them for Tab.
installInputModality();

// Inside the scanner kiosk shell the page is the scanner and nothing else: no
// login, no fleet fetch, no navbar. Everywhere else is the full app.
ReactDOM.render(
  inShell() ? (
    <ShellApp />
  ) : (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ),
  document.getElementById('root')
);

// The shell has no UpdatePrompt, so a precached bundle would never be replaced
// there. It always loads from the network instead.
if (inShell()) {
  serviceWorkerRegistration.unregister();
} else {
  // Register the service worker and notify the React tree when an update is ready
  serviceWorkerRegistration.register({
    onUpdate: (registration, { atLoad }) => {
      document.dispatchEvent(
        new CustomEvent('swUpdateAvailable', { detail: { registration, atLoad } })
      );
    },
  });
}
